import { render, staticRenderFns } from "./FilesCard.vue?vue&type=template&id=bbc02ee2&scoped=true&lang=pug&"
import script from "./FilesCard.vue?vue&type=script&lang=ts&"
export * from "./FilesCard.vue?vue&type=script&lang=ts&"
import style0 from "./FilesCard.vue?vue&type=style&index=0&id=bbc02ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc02ee2",
  null
  
)

export default component.exports